export const ODS_PROVIDER_NAME_ZAVA = 'zava'
